export const PUBLIC_APPLICATION_DEPLOYMENT_MODES = [
  "http_domain",
  "http_ip",
  "https_ip",
  "https_domain",
] as const;

export type PublicApplicationDeploymentMode =
  (typeof PUBLIC_APPLICATION_DEPLOYMENT_MODES)[number];
